module.exports = {
    zh: {
        addMenu: '新建菜单',
        number:"序号",
        menuName: '菜单名称',
        createTime: '创建时间',
        operation: '操作',
        cancel: '取消',
        determine: '确定',
        uploadFile: '上传文件',
        addFolder: '新建文件夹',
        search: '搜索',
        allFolder: '全部文件',
        documentName: '文档名称',
        documentType: '文档类型',
        founder: '创建人',
        edit: "编辑",
        delete:'删除',
        download: '下载',
        share: '分享',
        folderName: '文件夹名称',
        chooseFile: '选择文件',
        fileTitle: '文件标题',
        editFile: '编辑文件',
        choose: '选择',
        addAttachment: '添加附件',
        commentsSection: '评论区',
        addAttachments: '添加附件',
        viewFile: '查看文件'
    },
    en: {
        add: 'add menu',
        number:"number",
        menuName: 'The name of the menu',
        createTime: 'Creation time',
        operation: 'operation',
        confirm:'confirm',
        cancel: 'cancel',
        determine: 'determine',
        uploadFile: 'Upload a file',
        addFolder: 'The new folder',
        search: 'search',
        allFolder: 'All documents',
        documentName: 'The document name',
        documentType: 'The document type',
        founder: 'founder',
        edit: "edit",
        delete:'delete',
        download: 'download',
        share: 'share',
        folderName: 'The name of the folder',
        chooseFile: 'Select the file',
        fileTitle: 'The file header',
        editFile: 'Edit the file',
        choose: 'choose',
        addAttachment: 'Add attachments',
        commentsSection: 'The comments section',
        addAttachments: 'Add attachments',
        viewFile: 'view File'
    }
  }
  



// WEBPACK FOOTER //
// ./src/components/i18n/lang/QA.js